import { ExportFormatID } from 'devexpress-reporting/viewer/constants.js';

const KNOWN_EXPORT_FORMATS = Object.values(ExportFormatID);

export function applyViewerExportFormatPolicy(eventOrArgs, allowedFormats) {
    if (!Array.isArray(allowedFormats) || allowedFormats.length === 0) return;
    const args = eventOrArgs?.args ?? eventOrArgs;
    const allowed = new Set(allowedFormats.map((format) => String(format).toLowerCase()));
    for (const format of KNOWN_EXPORT_FORMATS) {
        if (!allowed.has(String(format.format).toLowerCase())) {
            args?.HideFormat?.(format);
        }
    }
}

export const VIEWER_EXPORT_FORMAT_IDS = ExportFormatID;
